<template >
  <v-app class>
    <v-content
      :id="$router.history.current.path.split('/')[1].length > 0 ? 'content_'+$router.history.current.path.split('/')[1] : 'content_login'"
    >
      <router-view></router-view>
    </v-content>
    <v-icon class="c_custom-loader">cached</v-icon>
    <v-progress-linear class="c_custom-progress" color="teal" height="20" :value="progressBar"></v-progress-linear>
    <h4 class="c_custom-msg"></h4>
  </v-app>
</template>
<script>
export default {
  computed: {
    progressBar() {
      return this.$store.getters.progressBar;
    },
  },
  components: {}
};
</script>
<style lang="scss">
@import "~styles/colors.scss";
@import "~styles/default.scss";
@import "~styles/resetVuetify.scss";
@import "~styles/primAcesso.scss";
@import "~styles/globalLoading.scss";
@import "~styles/dataTable.scss";
@import "~styles/centralNotificacao.scss";
@import "~styles/dashBoard.scss";
@import "~styles/sideBar.scss";
@import "~styles/snackBar.scss";
@import "~styles/panelEmpresa.scss";
@import "~styles/login.scss";
@import "~styles/cadastroConta.scss";
@import "~styles/relatorio.scss";
@import "~styles/fechamentoMensal.scss";
</style>


// WEBPACK FOOTER //
// src/App.vue